<template>
    <div class="judges-wrap">
        <div class="judges-nav">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>比赛专区</el-breadcrumb-item>
                <el-breadcrumb-item>开始比赛</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="judges-table">
            <el-table :data="tableData" stripe style="width: 100%">
                <el-table-column prop="scene" label="场次">
                    <template slot-scope="scope">第{{ scope.row.id }}场</template>
                </el-table-column>
                <el-table-column prop="category" label="类目"></el-table-column>
                <el-table-column prop="duration" label="时长"></el-table-column>

                <el-table-column label="操作" fixed="right" width="120">
                    <template slot-scope="scope">
                        <el-button
                            @click="startExamClick(scope.row.id)"
                            type="primary"
                            plain
                            size="small"
                            >开始比赛</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import { getStartRaces, startRace } from '@/api/races.js';
export default {
    name: 'startexam',
    data() {
        return {
            tableData: []
        };
    },
    methods: {
        //获取开始列表
        getstartracesList() {
            let that = this;
            getStartRaces().then(response => {
                if (response) {
                    that.tableData = response;
                }
            });
        },
        //开始考试
        startExamClick(id) {
            let that = this;
            that.$confirm('开始所选场次比赛吗', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnClickModal: false,
                type: 'warning'
            })
                .then(() => {
                    startRace(id).then(response => {
                        if (response.result) {
                            that.$message({
                                type: 'success',
                                message: '第' + id + '场比赛已开始'
                            });
                            this.getstartracesList();

                            this.$router.push({ path: '/judges/currentexam' });
                            this.$router.go(0);
                        } else {
                            that.$message({
                                type: 'warning',
                                message: response.msg
                            });
                        }
                    });
                })
                .catch(() => {});
        }
    },
    mounted() {
        this.getstartracesList();
    }
};
</script>

<style></style>
